<template>
  <VRow class="justify-center">
    <VDialog v-model="isVisible" persistent max-width="50%">
      <VCard>
        <VContainer>
          <VCardText>
            <VRow class="my-2 justify-center">
              <span class="text-display-large">{{ browserMessage(1) }}</span>
            </VRow>
            <VRow class="justify-center mt-4">
              <span class="text-headline-medium">{{ browserMessage(2) }}</span>
            </VRow>
            <VRow class="justify-center my-4">
              <span class="text-headline-medium">{{ browserMessage(3) }}</span>
            </VRow>
            <VRow class="justify-space-between">
              <VCol
                v-for="(limit, browser) in versionLimits"
                :key="browser"
                class="align-self-center"
              >
                <VIcon color="primary" size="90" class="mb-2">
                  <span :class="getBrowserIconClass(browser)" />
                </VIcon>
                <p>{{ $t(`browser.${browser}`) }} : {{ limit.max }}+</p>
              </VCol>
            </VRow>
            <VRow class="justify-center">
              <span>{{ browserMessage(4) }}</span>
            </VRow>
          </VCardText>
          <VCardActions class="justify-center">
            <VBtn color="error" class="mx-5" text @click="dismissModal">
              {{ $t("button.understood") }}
            </VBtn>
          </VCardActions>
        </VContainer>
      </VCard>
    </VDialog>
  </VRow>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { browserPatterns, browserIcons, versionLimits } from "@/const/browser";
import type { VersionLimit } from "@/const/browser";

export default defineComponent({
  name: "BBrowserCompatibilityModal",

  data() {
    return {
      versionLimits,
      browserPatterns,
      isVisible: false,
      isBrowserOutdated: false,
    };
  },

  mounted() {
    const isModalDismissed = localStorage.getItem("browserCompatibilityModalDismissed");
    if (!isModalDismissed) {
      this.isVisible = false;
      this.checkBrowserCompatibility();
    }
  },

  methods: {
    browserMessage(index: number) {
      const messageKey = this.isBrowserOutdated ? "browserVeryOutdated" : "browserOutdated";
      return this.$t(`browser.browserMessage.${messageKey}.${index}`);
    },

    dismissModal() {
      localStorage.setItem("browserCompatibilityModalDismissed", "true");
      this.isVisible = false;
    },

    checkBrowserCompatibility() {
      const browserName = this.getBrowserName() as null | keyof VersionLimit;
      if (browserName) {
        this.checkBrowserVersion(browserName);
      }
    },

    getBrowserName() {
      const browser = navigator.userAgent.toLowerCase();

      switch (true) {
        case browser.includes("edg"):
          return "edge";
        case browser.includes("opr"):
          return "opr";
        case browser.includes("chrome"):
        case browser.includes("chromium"):
        case browser.includes("crios"):
          return "chrome";
        case browser.includes("firefox"):
        case browser.includes("fxios"):
          return "firefox";
        case browser.includes("safari"):
          return "safari";
        default:
          return null;
      }
    },

    checkBrowserVersion(browserName: keyof VersionLimit) {
      const version = this.getBrowserVersion(browserName);
      const limits = this.versionLimits[browserName];

      if (limits && version) {
        if (parseFloat(version) < limits.min) {
          //   Rediriger vers la route "/outdated" avec les paramètres
          //      this.$router.push({
          //   path: "/outdated",
          //   query: {
          //     name: browserName,
          //     version: version,
          //   },
          // });

          // Navigateur très obsolète
          this.isVisible = localStorage.getItem("browserCompatibilityModalDismissed") !== "true";
          this.isBrowserOutdated = true;
        } else if (parseFloat(version) <= limits.max) {
          // Afficher la modal si la version est acceptée mais ancienne
          this.isVisible = localStorage.getItem("browserCompatibilityModalDismissed") !== "true";
        }
      }
    },

    getBrowserVersion(browserName: keyof VersionLimit) {
      const userAgent = navigator.userAgent;
      const pattern = this.browserPatterns[browserName];
      const match = pattern ? userAgent.match(pattern) : null;
      return match ? match[1] : undefined;
    },

    getBrowserIconClass(browser: keyof VersionLimit) {
      return browserIcons[browser] || "";
    },
  },
});
</script>

<style lang="css" scoped>
h1,
h3,
p,
span {
  color: #003662;
}

h1 {
  line-height: 1.5;
  text-align: center;
}

p {
  font-size: 16px;
  font-weight: bold;
}
</style>
